import { render, staticRenderFns } from "./PropsGuard.vue?vue&type=template&id=32afcb09"
import script from "./PropsGuard.vue?vue&type=script&lang=ts"
export * from "./PropsGuard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('32afcb09')) {
      api.createRecord('32afcb09', component.options)
    } else {
      api.reload('32afcb09', component.options)
    }
    module.hot.accept("./PropsGuard.vue?vue&type=template&id=32afcb09", function () {
      api.rerender('32afcb09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/guards/PropsGuard.vue"
export default component.exports